import { JournalEntryFormState } from './journalForm';

export const getActiveJournalLines = (lines: JournalEntryFormState['lines']) =>
  lines.filter(
    (line) => line.accountId || line.debit || line.credit || line.description,
  );

export const validateJournalLines = (
  lines: JournalEntryFormState['lines'],
): string | null => {
  if (!lines.length) {
    return 'Add at least one journal line before saving.';
  }

  const hasInvalidLine = lines.some((line) => {
    const debit = Number(line.debit || 0);
    const credit = Number(line.credit || 0);

    return (
      !line.accountId || !(debit > 0 || credit > 0) || (debit > 0 && credit > 0)
    );
  });

  if (hasInvalidLine) {
    return 'Each line must have an account and either a debit or a credit amount.';
  }

  return null;
};
